import { render, staticRenderFns } from "./ExtremeEventSelect.vue?vue&type=template&id=07fde2f3&scoped=true"
import script from "./ExtremeEventSelect.vue?vue&type=script&lang=js"
export * from "./ExtremeEventSelect.vue?vue&type=script&lang=js"
import style0 from "./ExtremeEventSelect.vue?vue&type=style&index=0&id=07fde2f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fde2f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VCol,VRow,VSelect})
